import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import defaultLiveCourseHeader from "@assets/images/default_live_course_header.jpg";
import { Livecourse } from "@domain/livecourse/livecourse";
import { ImageVersions } from "@domain/media/dtos";
import { useHover } from "@utils/hooks";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { mobile } from "@ui/styles/utils";
import { BadgeLabel } from "@ui/components/badgeLabel";
import { LiveCourseIcons } from "@ui/components/icons";
import { LivecourseMenu } from "./livecourseMenu";

interface LivecourseHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	livecourse: Livecourse;
}
export const LivecourseHeader: React.FC<LivecourseHeaderProps> = ({ livecourse, ...htmlProps }) => {
	const { banner } = livecourse;
	const { ref, isHovered } = useHover();

	return (
		<Container {...htmlProps} ref={ref}>
			<StyledBackgroundImage
				isHovered={isHovered}
				image={banner}
				defaultUrl={!banner ? defaultLiveCourseHeader : undefined}
				size={ImageVersions.MEDIUM}
				backdrop
				isBackLinearGradient
			/>

			<ContentBadge
				renderIcons={() => <LiveCourseIcons />}
				badgeTitle={I18n.t("live.thumbnail.badge_label")}
				isHovered={isHovered}
				hoverWidth={165}
			/>
			<Menu blur />
		</Container>
	);
};

const Container = styled.div`
	position: relative;
`;

const StyledBackgroundImage = styled(BackgroundImage)`
	border-top-left-radius: 13px;
	border-top-right-radius: 13px;
	overflow: hidden;
	height: 160px;
	@media ${mobile} {
		height: 235px;
	}
`;

const Menu = styled(LivecourseMenu)`
	position: absolute;
	right: 20px;
	top: 20px;
`;

const ContentBadge = styled(BadgeLabel)`
	position: absolute;
	top: 0px;
	left: 20px;
`;
